<header>
    <div class="icon-back" (click)="back()">
        <mat-icon>arrow_back</mat-icon> 
        </div>
    <p class="header-tittle">Datos fiscales y legales</p>
</header>
<app-navigation [currentStep]="4" [countSteppers]="7"></app-navigation>

<form class="layout-form" [formGroup]="taxForm" (ngSubmit)="onSubmit()">
  <div class="component-content">
    <div class="header-text-container">
      <span class="header-text">Un paso legal, pero rápido. ¡Ya casi estás!
      </span>
    </div>
    <div class="scroll-display">
      <div class="form-select-content">
        <app-text-input
          id="cuit-input"
          data-testid="cuit-input"
          [labelText]="'CUIT / CUIL'"
          [type]="'number'"
          [min]="11"
          [max]="11"
          [required]="true"
          formControlName="cuit"
          [submitted]="submitted"
        >
        </app-text-input>
        <label class="warning-label" *ngIf="warningCuit || isDuplicated">
          {{ warningCuitText }}
        </label>
      </div>
      <div *ngIf="infoCuil">
        <div class="form-customer-data" data-testid="razon-social-info">
          <p class="input-tittle">Razón Social</p>
          <p class="input-response">{{ infoCuil.lastName }} {{ infoCuil.name }}</p>
        </div>
      </div>
      <div *ngIf="infoAfip">
        <div
          class="form-customer-data"
          [attr.data-testid]="'razon-social-info'"
        >
          <p class="input-tittle">Razón Social</p>
          <p class="input-response">{{ infoAfip.bussinesName }}</p>
        </div>
        <div
          class="form-customer-data"
          [attr.data-testid]="'condicion-iva-info'"
        >
          <p class="input-tittle" >Condición de IVA</p>
          <p class="input-response">{{ infoAfip.ivaCondition }}</p>
        </div>
        <div
          class="form-customer-data"
          [attr.data-testid]="'domicilio-fiscal-info'"
        >
          <p class="input-tittle">Domicilio Fiscal</p>
          <p class="input-response">{{ infoAfip.taxResidence }}</p>
        </div>
      </div>
      <div class="form-select-content" *ngIf="IIBBOptions.length > 1">
        <app-select
          id="brutos-condition-select"
          [attr.data-testid]="'condition-iibb'"
          *ngIf="!this.convenioMultilateral && !this.simplifiedMonotributo"
          [labelText]="'Condición respecto a Ingresos Brutos'"
          [placeholder]="'Seleccionar'"
          [required]="true"
          formControlName="IIBBCondition"
          [submitted]="submitted"
          [options]="IIBBOptions"
        >
        </app-select>
        <div
          *ngIf="this.convenioMultilateral"
          class="form-customer-data"
          [attr.data-testid]="'convenio-multilateral-resp-afip'"
        >
          <p class="input-tittle">Condición respecto a Ingresos Brutos:</p>
          <p class="input-response">CONVENIO MULTILATERAL</p>
        </div>
        <div
          *ngIf="taxForm.controls['IIBBCondition'].value == 4"
          class="form-customer-data"
        >
          <p class="input-response">
            Se solicitará adjuntar en la próxima pantalla Formulario CM05 con
            acuse de recibo del año anterior y la Constancia Padrón Web con
            fecha de emisión menor a 30 días
          </p>
          <br />
          <app-select-filter
            id="jurisdiction-iibb-select"
            [attr.data-testid]="'jurisdiction-iibb'"
            [labelText]="'Jurisdicción sede de Ingresos Brutos'"
            [placeholder]="'Seleccionar'"
            [required]="showJurisdiction"
            (model)="this.taxForm.controls['iibbJurisdiction'].setValue($event)"
            [submitted]="submitted"
            [options]="jurisdictions"
            [hidden]="!showJurisdiction"
          >
          </app-select-filter>
        </div>
        <div
          *ngIf="this.simplifiedMonotributo"
          class="form-customer-data"
          [attr.data-testid]="'regimen-simplificado-resp-afip'"
        >
          <p class="input-tittle">Condición respecto a Ingresos Brutos:</p>
          <p class="input-response">REGIMEN SIMPLIFICADO</p>
        </div>
      </div>
      <div class="form-select-content">
        <app-text-input
          id="iibb-number-input"
          [attr.data-testid]="'numero-iibb'"
          [disabled]="
            this.taxForm.controls['IIBBCondition'].value == 1 ||
            !this.taxForm.controls['IIBBCondition'].value
          "
          [labelText]="'Número de IIBB'"
          [type]="'number'"
          [required]="numberIIBBRequired"
          formControlName="IIBBNumber"
          [max]="11"
          [submitted]="submitted"
        >
        </app-text-input>
      </div>

      <div
        class="form-checkbox"
        *ngIf="
          municipalContribution && this.infoAfip?.municipalContribution != 'E'
        "
      >
        <mat-checkbox id="municipal-checkbox" formControlName="municipalContribution">
          Inscripto en la Municipalidad
        </mat-checkbox>
        <div class="form-select-content">
          <app-text-input
            id="municipal-contribution-number-input"
            *ngIf="
              state == 'Chubut' &&
              this.taxForm.controls['municipalContribution'].value
            "
            [attr.data-testid]="'reba-num-patente'"
            [labelText]="'Número de contribucion municipal'"
            [type]="'string'"
            [required]="true"
            formControlName="numMunicipalContribution"
            [submitted]="submitted"
          >
          </app-text-input>
        </div>
      </div>
      <div
        *ngIf="
          municipalContribution && this.infoAfip?.municipalContribution == 'E'
        "
        class="form-customer-data"
        [attr.data-testid]="'inscripto-municipal'"
      >
        <p>Se encuentra inscripto en CONTRIBUCIÓN MUNICIPAL - CÓRDOBA</p>
      </div>
      <div class="form-checkbox" *ngIf="REBA">
        <mat-checkbox id="reba-checkbox" (change)="requiredReba($event)" formControlName="REBA">
          Cuento con Licencia para Venta de Bebidas Alcohólicas
        </mat-checkbox>
      </div>
      <div *ngIf="taxForm.controls['REBA'].value">
        <div class="form-select-content">
          <app-text-input
            id="reba-patent-number-input"
            [attr.data-testid]="'reba-num-patente'"
            [labelText]="'Número de Patente'"
            [type]="'string'"
            [required]="true"
            formControlName="codeREBA"
            [submitted]="submitted"
          >
          </app-text-input>
        </div>
        <div class="form-select-content">
          <app-text-input
            id="reba-expiration-date-input"
            [attr.data-testid]="'reba-fecha-vencimiento'"
            [labelText]="'Fecha de Vencimiento'"
            [type]="'date'"
            [required]="true"
            formControlName="expiredREBA"
            [submitted]="submitted"
          >
          </app-text-input>
        </div>
      </div>
    </div>
  </div>
</form>
<div class="button-container">
  <!-- <button [disabled]="isDuplicated" mat-raised-button class="next-button next-button__60" type="submit">
    Siguiente
  </button> -->
  <button id="tax-continue-button" [disabled]="isDuplicated"  mat-raised-button class="next-button" type="button" (click)="onSubmit()">Continuar</button>
</div>
